export class Gift {
  id = '';
  extra = '';
  completed = false;
}
